import { render } from "./StorageObjectsTable.vue?vue&type=template&id=219b255c&scoped=true&ts=true"
import script from "./StorageObjectsTable.vue?vue&type=script&lang=ts"
export * from "./StorageObjectsTable.vue?vue&type=script&lang=ts"

import "./StorageObjectsTable.vue?vue&type=style&index=0&id=219b255c&scoped=true&lang=scss"
import "./StorageObjectsTable.vue?vue&type=style&index=1&id=219b255c&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-219b255c"]])

export default __exports__